module.exports = "/static/assets/d4ec3992fc5543c54a79d924c51fa447.png";